export default __webpack_public_path__ + "static/media/Loading.706124a2.gif";